<template>
  <div class="edit-post" >
    <div class="content quill-editor-container" >
      <div id="toolbar">
        <span class="ql-formats">
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button class="ql-strike"></button>
        </span>
        <span class="ql-formats">
            <button class="ql-blockquote"></button>
            <button class="ql-code-block"></button>
        </span>
        <span class="ql-formats">
            <button type="button" class="ql-header" value="1"></button>
            <button type="button" class="ql-header" value="2"></button>
        </span>
        <span class="ql-formats">
            <button id="cancel-button" @click="editorCancelChange"><i class="el-icon-fa-undo"></i></button>
            <button id="cancel-button" @click="editorResumeChange"><i class="el-icon-fa-redo"></i></button>
        </span>
        <span class="ql-formats">
            <button type="button" class="ql-list" value="ordered"></button>
            <button type="button" class="ql-list" value="bullet"></button>
        </span>
        <span class="ql-formats">
            <button type="button" class="ql-script" value="sub"></button>
            <button type="button" class="ql-script" value="super"></button>
        </span>
        <span class="ql-formats">
            <button type="button" class="ql-indent" value="-1"></button>
            <button type="button" class="ql-indent" value="+1"></button>
        </span>
        <span class="ql-formats">
            <button type="button" class="ql-direction" value="rtl"></button>
        </span>
        <span class="ql-formats">
            <select class="ql-size">
                <option value="small" />
                <option selected="selected" />
                <option value="large" />
                <option value="huge" />
            </select>
        </span>
        <span class="ql-formats">
            <select class="ql-header">
                <option value="1" />
                <option value="2" />
                <option value="3" />
                <option value="4" />
                <option value="5" />
                <option value="6" />
                <option selected="selected" />
            </select>
        </span>
        <span class="ql-formats">
          <select class="ql-color">
            <option selected="selected" />
            <option value="#e60000" />
            <option value="#ff9900" />
            <option value="#ffff00" />
            <option value="#008a00" />
            <option value="#0066cc" />
            <option value="#9933ff" />
            <option value="#ffffff" />
            <option value="#facccc" />
            <option value="#ffebcc" />
            <option value="#ffffcc" />
            <option value="#cce8cc" />
            <option value="#cce0f5" />
            <option value="#ebd6ff" />
            <option value="#bbbbbb" />
            <option value="#f06666" />
            <option value="#ffc266" />
            <option value="#ffff66" />
            <option value="#66b966" />
            <option value="#66a3e0" />
            <option value="#c285ff" />
            <option value="#888888" />
            <option value="#a10000" />
            <option value="#b26b00" />
            <option value="#b2b200" />
            <option value="#006100" />
            <option value="#0047b2" />
            <option value="#6b24b2" />
            <option value="#444444" />
            <option value="#5c0000" />
            <option value="#663d00" />
            <option value="#666600" />
            <option value="#003700" />
            <option value="#002966" />
            <option value="#3d1466" />
          </select>
          <select class="ql-background">
            <option value="#000000" />
            <option value="#e60000" />
            <option value="#ff9900" />
            <option value="#ffff00" />
            <option value="#008a00" />
            <option value="#0066cc" />
            <option value="#9933ff" />
            <option selected="selected" />
            <option value="#facccc" />
            <option value="#ffebcc" />
            <option value="#ffffcc" />
            <option value="#cce8cc" />
            <option value="#cce0f5" />
            <option value="#ebd6ff" />
            <option value="#bbbbbb" />
            <option value="#f06666" />
            <option value="#ffc266" />
            <option value="#ffff66" />
            <option value="#66b966" />
            <option value="#66a3e0" />
            <option value="#c285ff" />
            <option value="#888888" />
            <option value="#a10000" />
            <option value="#b26b00" />
            <option value="#b2b200" />
            <option value="#006100" />
            <option value="#0047b2" />
            <option value="#6b24b2" />
            <option value="#444444" />
            <option value="#5c0000" />
            <option value="#663d00" />
            <option value="#666600" />
            <option value="#003700" />
            <option value="#002966" />
            <option value="#3d1466" />
          </select>
        </span>
        <span class="ql-formats">
          <select class="ql-font">
            <option selected="selected" />
            <option value="serif" />
            <option value="monospace" />
          </select>
        </span>
        <span class="ql-formats">
          <select class="ql-align">
            <option selected="selected" />
            <option value="center" />
            <option value="right" />
            <option value="justify" />
          </select>
        </span>
        <span class="ql-formats">
            <button type="button" class="ql-clean"></button>
        </span>
        <span class="ql-formats">
            <button type="button" class="ql-link"></button>
            <button type="button" class="ql-image"></button>
            <button type="button" class="ql-video"></button>
        </span>
      </div>
      <el-input
         v-if="htmlMode"
         class="quill-editor"
         resize="none"
         type="textarea"
         @change="change"
         v-model="content" >
      </el-input>
      <quill-editor
         v-else
         ref="editor"
         v-model="content"
         :options="quill"
         @change="change" >
      </quill-editor>
    </div>
    <div class="menu-right" >
      <el-form class="options" >
        <el-form-item label="Titre" >
          <el-input v-model="title" @change="change" ></el-input>
        </el-form-item>
        <el-form-item label="" >
          <el-checkbox v-model="widget" @change="change" label="Utiliser comme Widget" >
          </el-checkbox>
          <el-checkbox v-model="event" @change="change" label="Utiliser comme Événement" >
          </el-checkbox>
          <el-checkbox v-model="draft" @change="change" label="Brouillon" >
          </el-checkbox>
          <el-checkbox v-model="hasCommentaries" @change="change" label="Commentaires" >
          </el-checkbox>
        </el-form-item>
        <el-form-item v-if="allowHTML" label="Mode avancé (HTML)" >
          <el-switch
             v-model="htmlMode"
             active-color="#13ce66"
             inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item label="Date de publication" >
          <el-date-picker
             v-model="published"
             type="datetime"
             placeholder="Choisir une date"
             @change="change"
             ></el-date-picker>                
        </el-form-item>
        <el-form-item label="Date d'expiration" >
          <el-date-picker
             v-model="expiresAt"
             type="datetime"
             placeholder="Choisir une date"
             @change="change"
             ></el-date-picker>                
        </el-form-item>
        <el-form-item label="Miniature" class="miniature" >              
          <el-radio-group size="small" v-model="miniatureMode" @change="change" >
            <el-radio-button label="image" ></el-radio-button>
            <el-radio-button label="vidéo" ></el-radio-button>
          </el-radio-group>
          <el-upload
             v-if="miniatureMode === 'image'"
             class="preview-uploader"
             action="dummy"
             :auto-upload="false"
             accept="image/*"
             :on-change="handlePreviewChange"
             :show-file-list="false" >
            <img v-if="preview" :src="preview" class="preview" >
            <i v-else class="el-icon-plus preview-icon" ></i>
          </el-upload>
          <el-input v-else placeholder="Vidéo URL" v-model="videoURL" @change="change" ></el-input>
        </el-form-item>
        <div>
          <label class="el-form-item__label">Catégories</label>
          <post-tags v-model="tags" @change="change" ></post-tags>
        </div>
        <el-form-item label="Groupes" >
          <el-select
             ref="selectGroup"
             v-model="groups"
             :multiple="true"
             :filterable="true"
             :remote="true"
             placeholder="Rechercher un groupe..."
             :remote-method="searchGroup"
             @change="groupListChange"
             :loading="groupLoading" >
            <el-option
               v-for="group in groupList"
               :key="group.id"
               :label="group.name"
               :value="group.id" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="warning" @click="cancel" >
          Annuler
        </el-button>
        <el-button type="primary" @click="save" :disabled="!editing || content === null" >
          Sauvegarder
        </el-button>
        <is-granted
           :condition="{attribute: 'delete', subject: 'YWC\\MacaronsBlogBundle\\Entity\\Post'}"
           display="inline" >
          <el-button v-if="id" type="danger" @click="deletePost" >
            Supprimer
          </el-button>
        </is-granted>
      </el-form>
    </div>
  </div>
</template>

<style scoped>
.edit-post {
    display: flex;
}
.content {
    flex: 1;
}
.menu-right {
    padding: 0 10px;
}
.preview-uploader >>> .el-upload {
    width: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.preview-uploader >>> .el-upload:hover {
    border-color: #20a0ff;
}
.preview-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.preview {
    display: block;
    width: 100%;
}
.el-date-editor {
    width: 100%;
}
.el-checkbox {
    margin-left: 0;
}
.miniature .preview-uploader {
    margin-top: 8px;
}
.miniature >>> .el-form-item__label {
    margin-top: 3px;
}
.el-select {
    width: 100%;
}
.quill-editor, .quill-editor >>> textarea {
    height: 600px !important;
}
#toolbar {
    background: #fff;
}
.el-icon-fa-redo:before {
    content: "\f01e";
}
</style>

<script>
import Vue from 'vue'
import PostTags from './PostTags.vue'
import VueQuillEditor, {Quill} from 'vue-quill-editor'
import {api, imageutils, IsGranted} from 'macarons'
import Post from './Post.vue'
import moment from 'moment'
Vue.use(VueQuillEditor)

export default {
  components: {
    PostTags: PostTags,
    IsGranted: IsGranted
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
        }
      }
    },
  },
  data () {
    return {
      title: null,
      content: null,
      preview: null,
      videoURL: null,
      groupLoading: false,
      groups: [],
      groupList: [],
      tags: [],
      published: null,
      expiresAt: null,
      miniatureMode: 'image',
      id: null,
      debounce: null,
      allowHTML: false,
      htmlMode: false,
      widget: false,
      event: false,
      draft: true,
      hasCommentaries: true,
      editing: false,
      loaded: false,
      quill: {
        modules: {
          clipboard: {
            matchVisual: false
          },
          toolbar: '#toolbar'
        }
      }
    }
  },
  watch: {
    value () {
      this.load()
    },
    editing () {      
      this.$emit('change', this.editing)
    }
  },
  mounted () {
    this.load().then(() => {
      this.handlePopupPlacement()
    })
  },
  methods: {
    load (value) {
      this.loaded = false
      value = typeof value === 'undefined' ? this.value : value
      this.allowHTML = false
      if (value.id) {
        return Promise.all([
          this.$store.dispatch('isGranted', {
            attribute: 'unsafe-html',
            subject: {
              type: 'entity',
              classname: 'YWC\\MacaronsBlogBundle\\Entity\\Post',
              id: value.id
            }
          }).then(allow => {
            this.allowHTML = allow
          }),
          api.get('blog/post/' + value.id).then(({data}) => {
            this.id = value.id
            this.title = data.title
            this.content = data.content
            if (data.preview === null || data.preview.match(/https?:\/\/.*/) === null) {
              this.preview = data.preview
              this.videoURL = null
              this.miniatureMode = 'image'
            } else {
              this.preview = null
              this.videoURL = data.preview
              this.miniatureMode = 'video'
            }
            this.groups.splice(0, this.groups.length, ...data.groups.map(g => g.id))
            this.groupList.splice(0, this.groupList.length, ...data.groups)
            this.tags.splice(0, this.tags.length, ...data.tags)
            this.published = moment(data.published).toDate()
            if (typeof data.expires_at === 'undefined' && !(typeof data.expiresAt === 'undefined')) {
              data.expires_at = data.expiresAt
            }
            this.expiresAt = data.expires_at === null ? null : moment(data.expires_at).toDate()
            this.widget = data.widget
            this.event = data.event
            this.draft = data.draft
            this.hasCommentaries = data.has_commentaries
            this.$nextTick(() => {
              this.editing = false
              this.loaded = true
            })
          })
        ])
      } else {      
        this.$store.dispatch('isGranted', {
          attribute: 'unsafe-html',
          subject: 'YWC\\MacaronsBlogBundle\\Entity\\Post'
        }).then(allow => {
          this.allowHTML = allow
        })
        this.id = null
        this.content = null
        this.preview = null
        this.videoURL = null
        this.miniatureMode = 'image'
        this.groups.splice(0)
        this.groupList.splice(0)
        this.tags.splice(0)
        this.published = null
        this.expiresAt = null
        this.widget = false
        this.event = false
        this.draft = true
        this.hasCommentaries = true
        this.$nextTick(() => {
          this.editing = false
          this.loaded = true
        })
        return Promise.resolve()
      }
    },
    change () {
      if (this.loaded) {
        this.editing = true
      }
    },
    cancel () {
      this.$emit('cancel')
      this.load()
    },
    formatDate (date) {
      if (date instanceof Date && !isNaN(date.valueOf())) {
        return moment(date).format('YYYY-MM-DDTHH:mm:ssZ')
      }
      return null
    },
    save () {
      const data = {
        title: this.title,
        content: this.content,
        widget: this.widget,
        event: this.event,
        draft: this.draft,
        hasCommentaries: this.hasCommentaries,
        tags: this.tags.map(tag => tag.id),
        preview: this.miniatureMode === 'image' ? this.preview : this.videoURL,
        published: this.formatDate(this.published),
        expiresAt: this.formatDate(this.expiresAt),
        groups: this.groups
      }
      if (this.id === null) {
        api.put('blog/post', data).then(({data}) => {
          this.id = data.id
          this.editing = false
          if (data.widget) {
            this.registerWidget(data)
          }
          this.$emit('save', this.id)
        })
      } else {
        api.patch('blog/post/' + this.id, data).then(({data}) => {
          this.editing = false          
          if (data.widget) {
            this.registerWidget(data)
          }
          this.$emit('save', this.id)
        })
      }
    },    
    deletePost () {
      api.delete('blog/post/' + this.id).then(() => {
        this.$emit('delete', this.id)
        this.load({})
      })
    },
    registerWidget (widget) {
      this.$store.commit('registerWidget', {
        label: widget.title,
        id: 'blog-post-' + widget.id,
        component: Post,
        options: {
          widget: widget
        }
      })
    },
    groupListChange () {
      if (typeof this.$refs.selectGroup !== 'undefined') {
        Vue.set(this.$refs.selectGroup, 'query', '');
      }
      this.change()
    },
    handlePopupPlacement () {
      if (this.$refs.selectGroup && this.$refs.selectGroup.$refs.popper && this.$refs.selectGroup.$refs.popper.popperJS) {
        this.$refs.selectGroup.$refs.popper.popperJS.onUpdate(popper => {
          popper.placement = 'top-end'
          clearTimeout(this.debounce)
          this.debounce = setTimeout(() => {
            popper.instance.update()
          }, 100)
        })
      } else {
        setTimeout(this.handlePopupPlacement, 1000)
      }
    },
    handlePreviewChange (file) {
      imageutils.resize(file.raw, 500, 300).then(data => {
        this.preview = data
        this.change()
      })
    },
    searchGroup (query) {
      if (query === '') {
        this.groupList = []
      } else {
        this.groupLoading = true
        api.post('groups/autocomplete', {
          query: query
        }).then(response => {
          this.groupList.splice(0, this.groupList.length, ...response.data)
          this.groupLoading = false
        })
      }
    },
    editorCancelChange() {
        document.execCommand('undo', false, null);
    },
    editorResumeChange() {
        document.execCommand('redo', false, null);
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-blog/EditPost.vue